import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import Home from './pages/Home';
import Research from './pages/Research';
import FundingSources from './pages/FundingSources';
import Members from './pages/Members';
import MemberDetail from './pages/MemberDetail';
import Publications from './pages/Publications';
import PublicationDetail from './pages/PublicationDetail';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Recruitment from './pages/Recruitment';
import RecruitmentDetail from './pages/RecruitmentDetail';
import Contact from './pages/Contact';
import Login from './pages/Login';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminMembers from './pages/admin/AdminMembers';
import AdminNews from './pages/admin/AdminNews';
import AdminNewsGallery from './pages/admin/AdminNewsGallery';
import AdminPublications from './pages/admin/AdminPublications';
import AdminRecruitment from './pages/admin/AdminRecruitment';
import AdminResearch from './pages/admin/AdminResearch';
import AdminFundingSources from './pages/admin/AdminFundingSources';
import AdminPageIntros from './pages/admin/AdminPageIntros';
import AdminMessages from './pages/admin/AdminMessages';
import AdminHomeHero from './pages/admin/AdminHomeHero';
import AdminChangePassword from './pages/admin/AdminChangePassword';
import NotFound from './pages/NotFound';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="research" element={<Research />} />
        <Route path="funding-sources" element={<FundingSources />} />
        <Route path="members" element={<Members />} />
        <Route path="members/:id" element={<MemberDetail />} />
        <Route path="publications" element={<Publications />} />
        <Route path="publications/:id" element={<PublicationDetail />} />
        <Route path="news" element={<News />} />
        <Route path="news/:id" element={<NewsDetail />} />
        <Route path="recruitment" element={<Recruitment />} />
        <Route path="recruitment/:id" element={<RecruitmentDetail />} />
        <Route path="contact" element={<Contact />} />
      </Route>

      <Route path="/login" element={<Login />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute requireAdmin>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="members" element={<AdminMembers />} />
        <Route path="news" element={<AdminNews />} />
        <Route path="news-gallery" element={<AdminNewsGallery />} />
        <Route path="publications" element={<AdminPublications />} />
        <Route path="research" element={<AdminResearch />} />
        <Route path="funding-sources" element={<AdminFundingSources />} />
        <Route path="recruitment" element={<AdminRecruitment />} />
        <Route path="page-intros" element={<AdminPageIntros />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="home-hero" element={<AdminHomeHero />} />
        <Route path="change-password" element={<AdminChangePassword />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
